import { render, staticRenderFns } from "./menu-right.vue?vue&type=template&id=1458f700&scoped=true"
import script from "./menu-right.vue?vue&type=script&lang=js"
export * from "./menu-right.vue?vue&type=script&lang=js"
import style0 from "./menu-right.vue?vue&type=style&index=0&id=1458f700&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1458f700",
  null
  
)

export default component.exports